import { createAction } from "@reduxjs/toolkit";
import { forms } from "lobbie";

export const setKiosks = createAction<forms.IFormTemplateKiosk[]>("kiosks/set");
export const setKiosk = createAction<forms.IFormTemplateKiosk | undefined>("kiosk/set");
